import { render, staticRenderFns } from "./capturecard.vue?vue&type=template&id=83dd49e0&"
import script from "./capturecard.vue?vue&type=script&lang=js&"
export * from "./capturecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports